export default __webpack_public_path__ + "static/media/SairaExtraCondensed-Regular.ff10cfc1.ttf";